// datos step B (Roger oct21 11:36): the "Cliente reporta datos incorrectos" marker an advisor sees
// on a Revisiones row / card and in the Calendar cita detail, with the customer's own text and a
// "Marcar atendido" button once he corrected the datum in B.PRO (we never write client data).
import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { attendDatosDispute } from '../../services/appointmentsApi';
import { datosDisputeOf, datosDisputeText, formatDatosDispute, DATOS_DISPUTE_PENDING } from './datosDispute';

export default function DatosDisputeMarker({ row, compact = false, onChanged, testId = 'datos-dispute' }) {
  const { t } = useTranslation();
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const inFlight = useRef(false);
  const flag = datosDisputeOf(row);
  if (!flag) return null;
  const tr = (k, f) => { const v = t(k, f); return v === k ? f : v; };
  const pending = flag.status === DATOS_DISPUTE_PENDING;
  const summary = formatDatosDispute(flag, tr);
  const text = datosDisputeText(flag);
  if (compact) {
    return <div className={'mt-1 text-xs ' + (pending ? 'text-amber-700 dark:text-amber-300' : 'review-muted')} data-testid={testId}>
      {pending ? '⚠️ ' : '✓ '}{summary}{!pending ? ' · ' + tr('calendar.datosDispute.attended', 'Atendido') : ''}
    </div>;
  }
  async function attend() {
    if (inFlight.current || !pending || !onChanged) return;
    inFlight.current = true; setBusy(true); setError('');
    try {
      const response = await attendDatosDispute(row.appointment_id);
      const next = response?.data?.appointment;
      if (!next || next.appointment_id !== row.appointment_id) { setError('requestFailed'); return; }
      onChanged(next);
    } catch (err) {
      setError(err?.response?.status === 404 ? 'notFound' : 'requestFailed');
    } finally {
      inFlight.current = false; setBusy(false);
    }
  }
  return <section aria-label={tr('calendar.datosDispute.marker', 'Cliente reporta datos incorrectos')}
    className={'my-2 rounded border px-3 py-2 text-sm ' + (pending ? 'border-amber-400 bg-amber-50 dark:bg-amber-900/20' : 'border-gray-300 opacity-80')}
    data-testid={testId}>
    <p className="font-medium" data-testid={testId + '-summary'}>{pending ? '⚠️ ' : '✓ '}{summary}</p>
    {text && <p className="mt-1 whitespace-pre-wrap" data-testid={testId + '-text'}>
      <span className="review-muted">{tr('calendar.datosDispute.clientSaid', 'El cliente escribió')}:</span> “{text}”
    </p>}
    <p className="review-muted mt-1 text-xs">{tr('calendar.datosDispute.hint', 'Corríjalo en B.PRO; el sistema no modifica datos del cliente.')}</p>
    {pending
      ? (onChanged && <button type="button" disabled={busy}
        className="mt-2 rounded border border-amber-500 px-3 py-1 text-sm disabled:opacity-50"
        onClick={attend} data-testid={testId + '-attend'}>
        {busy ? tr('calendar.datosDispute.marking', 'Marcando…') : tr('calendar.datosDispute.markAttended', 'Marcar atendido')}
      </button>)
      : <p className="mt-1 text-xs" data-testid={testId + '-attended'}>
        {tr('calendar.datosDispute.attended', 'Atendido')}{flag.attended_by ? ` · ${flag.attended_by}` : ''}
      </p>}
    {error && <p role="alert" className="mt-1 text-xs text-red-700 dark:text-red-300">
      {tr('calendar.datosDispute.' + error, error === 'notFound' ? 'La cita ya no tiene este reporte.' : 'No se pudo marcar; vuelva a intentar.')}
    </p>}
  </section>;
}
